import { z } from "zod";

export const idSchema = () => z.string().uuid().or(z.literal("new"));
